
const DOODLES_COUNT = 100
const DOODLE_MAX_SIZE = 30
const SVG_NAME_SPACE = 'http://www.w3.org/2000/svg'

const addProjectScrollAreas = [
  ...document.getElementsByClassName('project-scroller')
]
const goToTopEl = document.getElementById('go-to-top')
const scrollIndicatorEl = document.getElementById('scroll-indicator')
const portfolioLinkEl = document.getElementById('portfolio-link')

let pageHeight = 1
let isHeightCollapsed = false

history.scrollRestoration = 'manual'
window.addEventListener('beforeunload', () => {
  window.scroll(0, 0)
})

goToTopEl.addEventListener('click', () => {
  window.scroll({
    top: 0,
    behavior: 'smooth',
  })
})

// const doodleEls = new Array(DOODLES_COUNT)
//   .fill(null)
//   .map((_, i) => {
//     const minDoodleSize = DOODLE_MAX_SIZE / 3
//     const maxDoodleSize = minDoodleSize * 2
//     const doodleSize = minDoodleSize + Math.random() * maxDoodleSize
//     const svg = document.createElementNS(SVG_NAME_SPACE, 'svg')
//     svg.setAttribute('xmlns', SVG_NAME_SPACE)
//     svg.setAttribute('version', '1.1')
//     svg.setAttribute('width', doodleSize)
//     svg.setAttribute('height', doodleSize)
//     svg.setAttribute('viewBox', `0 0 ${doodleSize} ${doodleSize}`)

//     const pathEl = document.createElementNS(SVG_NAME_SPACE, 'path')

//     function generatePathDefinition () {
//       let pathDefinition = ''

//       const maxPoints = Math.round(Math.random() * 2) + 1

//       for (let i = 0; i < maxPoints; i++) {
//         const x = Math.random() * DOODLE_MAX_SIZE
//         const y = Math.random() * DOODLE_MAX_SIZE
//         if (i === 0) {
//           pathDefinition += `M ${x} ${y}`  
//         } else {
//           const nextx = Math.random() * DOODLE_MAX_SIZE
//           const nexty = Math.random() * DOODLE_MAX_SIZE
//           const ctrlx = (x + nextx) / 2
//           const ctrly = (y + nexty) / 2
//           pathDefinition += ` Q ${x} ${y} ${ctrlx} ${ctrly}`
//         }
//       }

//       pathEl.setAttribute('d', pathDefinition)
//     }
//     generatePathDefinition()

//     setInterval(generatePathDefinition, 5000 + Math.random() * 5000)

//     pathEl.setAttribute('fill', 'none')
//     pathEl.setAttribute('stroke', 'rgba(0, 0, 0, 0.5)')
//     // pathEl.setAttribute('stroke', 'yellow')

//     svg.appendChild(pathEl)

//     svg.style.setProperty('position', 'fixed')
//     svg.style.setProperty('top', `${Math.random() * innerHeight}px`)
//     svg.style.setProperty('left', `${Math.random() * innerWidth}px`)
//     svg.style.setProperty('z-index', `-1`)

//     document.body.appendChild(svg)

//   })

document.addEventListener('DOMContentLoaded', () => {

  document.body.style.setProperty('opacity', '1')

  pageHeight = getPageHeight()

  const svgViewBoxWidth = 308.98
  const svgViewBoxHeight = 430.87

  const widthDelta = innerWidth / svgViewBoxWidth

  const svgRealViewBoxWidth = svgViewBoxWidth * widthDelta
  const svgRealViewBoxHeight = svgViewBoxHeight * widthDelta

  const svgPaddingBottom = 1 - 150 / innerHeight

  const heightDelta = (innerHeight * svgPaddingBottom) / svgRealViewBoxHeight

  const svgWidth = svgRealViewBoxWidth * heightDelta
  const svgHeight = svgRealViewBoxHeight * heightDelta

  const svgLabelElements = addProjectScrollAreas.map(el => {
    const descriptionEl = el.getElementsByClassName('project-description')[0]
    const name = (descriptionEl.dataset.name || 'undefined').toUpperCase()

    const maxWidth = 300
    const refFontSize = 40

    const svgEl = document.createElementNS(SVG_NAME_SPACE, 'svg')
    svgEl.setAttribute('xmlns', SVG_NAME_SPACE)
    svgEl.setAttribute('version', '1.1')
    svgEl.setAttribute('width', maxWidth)
    svgEl.setAttribute('height', 100)
    svgEl.setAttribute('viewBox', `0 0 ${maxWidth} 100`)

    const textEl = document.createElementNS(SVG_NAME_SPACE, 'text')
    textEl.textContent = name
    textEl.setAttribute('x', 0)
    textEl.setAttribute('y', 0)
    textEl.setAttribute('font-size', refFontSize)

    svgEl.appendChild(textEl)
    descriptionEl.appendChild(svgEl)
    
    setTimeout(() => {
      const bbox = textEl.getBBox()
      const widthDelta = maxWidth / bbox.width
      const realFontSize = refFontSize * widthDelta
      console.log(realFontSize)
      textEl.setAttribute('font-size', realFontSize * 1)
      textEl.setAttribute('stroke', 'black')
      textEl.setAttribute('fill', 'none')
      textEl.style.setProperty('opacity', 0)
      setTimeout(() => {
        textEl.style.setProperty('transition', 'opacity 0.3s ease-in')
      }, 0)
      
      setTimeout(() => {
        const bbox = textEl.getBBox()
        svgEl.setAttribute('viewBox', `0 0 ${maxWidth} ${bbox.height}`)
        svgEl.setAttribute('height', bbox.height)
        textEl.setAttribute('y', -bbox.y)
      }, 0)
    }, 0)

    return textEl
  })

  const replayButtons = addProjectScrollAreas.map(wrapper => {
    const button = wrapper.getElementsByTagName('button')[0]
    return button
  })
  
  addProjectScrollAreas.forEach(wrapper => {
    const svg = wrapper.getElementsByTagName('svg')[0]
    svg.setAttribute('width', svgWidth)
    svg.setAttribute('height', svgHeight)
    const paths = getSVGElements(svg)
    paths.forEach(path => {
      path.setAttribute('pathLength', '1')
      path.style.setProperty('stroke-dasharray', '1')
      path.style.setProperty('stroke-dashoffset', '1')
    })

    const button = wrapper.getElementsByTagName('button')[0]
    if (button) {
    button.addEventListener('click', () => {
      paths.forEach(path => {
        path.style.transition = 'none'
        path.style.setProperty('stroke-dashoffset', '1')
      })

      setTimeout(() => {
        paths.forEach(path => {
          path.style.transition = 'stroke-dashoffset 1.5s cubic-bezier(0.5, 0, 0.75, 0)'
          path.style.setProperty('stroke-dashoffset', '0')
        })
      }, 0)
    })
    }
  })

  const sectionBBoxes = addProjectScrollAreas.map(el => {
    const bbox = el.getBoundingClientRect()
    bbox.y = bbox.y + getScrollY()
    return bbox
  })

  const sectionsShouldAnimate = new Array(addProjectScrollAreas.length).fill(true)

  const sectionSVGElements = addProjectScrollAreas.map(getSVGElements)

  document.addEventListener('scroll', onScroll)

  document.addEventListener('scroll', () => {
    if (getScrollY() + innerHeight > pageHeight - 200) {
      goToTopEl.classList.add('visible')
    } else {
      goToTopEl.classList.remove('visible')
    }
  })

  function onScroll () {
    const scrollY = getScrollY()
    if (!scrollIndicatorEl.classList.contains('hidden')) {
      scrollIndicatorEl.classList.add('hidden')
    }

    sectionBBoxes.forEach((bbox, i, self) => {
      const svgElements = sectionSVGElements[i]
      if (scrollY >= bbox.y && scrollY < bbox.y + bbox.height) {
        const y = clampNumber(mapNumberRange(scrollY, bbox.y, bbox.y + bbox.height - innerHeight * 1.5, 0, 1), 0, 1)
        if (y > svgPaddingBottom) {
          svgLabelElements[i].style.setProperty('opacity', 1)
          replayButtons[i].style.setProperty('opacity', '1')
        }
        if (y === 1) {
          sectionsShouldAnimate[i] = false
          svgElements.forEach(svgEl => {
            svgEl.style.setProperty('stroke-dashoffset', 0)
          })
        }
        if (sectionsShouldAnimate[i]) {
          svgElements.forEach(svgEl => {
            svgEl.style.setProperty('stroke-dashoffset', 1 - y)
          })
        }
        if (i === self.length - 1 && y > 0.8) {
          if (!isHeightCollapsed) {
            addProjectScrollAreas.forEach(el => {
              el.style.setProperty('height', '100vh')
            })
            setTimeout(() => {
              pageHeight = getPageHeight()
            }, 1)
            isHeightCollapsed = true
          }

          sectionsShouldAnimate[i] = false
          svgElements.forEach(svgEl => {
            svgEl.style.setProperty('stroke-dashoffset', 0)
          })

          svgLabelElements[i].style.setProperty('opacity', 1)
        }
      }
    })
  }


  portfolioLinkEl.innerHTML = portfolioLinkEl.innerText.split('').map((char, i) => {
    if (char === ' ') {
      return `<span style="animation-delay: ${i * 0.1}s; width: 4px;"></span>`
    } else {
      return `<span style="animation-delay: ${i * 0.1}s;">${char}</span>`
    }
  }).join('')

})

function getSVGElements (parentNode = document.body) {
  return [
    ...parentNode.getElementsByTagName('path'),
    ...parentNode.getElementsByTagName('rect'),
    ...parentNode.getElementsByTagName('ellipse'),
    ...parentNode.getElementsByTagName('circle'),
    ...parentNode.getElementsByTagName('line'),
    ...parentNode.getElementsByTagName('polyline'),
    ...parentNode.getElementsByTagName('polygon')
  ]
}

function clampNumber (num, min, max) {
  return Math.min(Math.max(num, min), max)
}

function mapNumberRange (num, inMin, inMax, outMin, outMax) {
  return (num - inMin) * (outMax - outMin) / (inMax - inMin) + outMin
}

function getScrollY () {
  const supportPageOffset = window.pageXOffset !== undefined
  const isCSS1Compat = ((document.compatMode || '') === 'CSS1Compat')
  return supportPageOffset ? window.pageYOffset : isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop
}

function getPageHeight () {
  const body = document.body
  const html = document.documentElement

  const height = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight)
  return height
}
